import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const JobProductForm = forwardRef(({job, product, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={product}
      type="product"
      fieldsComponent={Fields}
      onSave={({product_id, quantity}) => services.job.saveProducts(job, [product_id], quantity)}
      onSaved={onSaved}
    />
  );
});

export default JobProductForm;
